import { HStack, VStack } from '@sgme/ui';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import type { IntlMessageId } from '@/types/intl';
import { getRateComponentStyling } from '@/utils/rateComponentStyling.ts';

import { RATES_CONTAINER_HEIGHT } from './constants.ts';

type IdleRatesComponentProps = {
  canTrade: boolean;
  bidMessageId?: IntlMessageId;
  askMessageId?: IntlMessageId;
};

/**
 * Component displayed when rates are in idle state
 */
export const IdleRatesComponent = ({
  canTrade,
  bidMessageId = 'CashTile.SpotRates.fillBid',
  askMessageId = 'CashTile.SpotRates.fillAsk',
}: IdleRatesComponentProps) => (
  <HStack fullWidth className="position-relative" style={{ height: RATES_CONTAINER_HEIGHT }} data-e2e="rates">
    <div className="w-50 h-100 border-end text-center text-secondary fw-semibold">
      <VStack
        horizontalAlignment="center"
        verticalAlignment="center"
        fullWidth
        fullHeight
        className={clsx('px-2 py-1', ...getRateComponentStyling({ executable: false, cantTrade: !canTrade }))}
      >
        <FormattedMessage id={bidMessageId} values={{ br: <br /> }} />
      </VStack>
    </div>

    <div className="w-50 h-100 text-center text-secondary fw-semibold">
      <VStack
        horizontalAlignment="center"
        verticalAlignment="center"
        fullWidth
        fullHeight
        className={clsx('px-2 py-1', ...getRateComponentStyling({ executable: false, cantTrade: !canTrade }))}
      >
        <FormattedMessage id={askMessageId} values={{ br: <br /> }} />
      </VStack>
    </div>
  </HStack>
);
